export default __webpack_public_path__ + "static/CardiffGardenRooms-736cb97c2c68228251163038b2daceed.jpg";